const { AWS_LIMITS } = require('../constants');

/**
 * 动态计算分片大小
 * @param {number} fileSize 文件大小
 * @returns {object} { chunkSize, numParts }
 */
function calculateChunkSize(fileSize) {
    const MAX_PARTS = AWS_LIMITS.MAX_PARTS;
    const MIN_CHUNK = AWS_LIMITS.MIN_CHUNK_SIZE;

    // 根据文件大小动态调整目标分片数
    let TARGET_PARTS;
    if (fileSize < 500 * 1024 * 1024) {
        TARGET_PARTS = 100;
    } else if (fileSize < 2 * 1024 * 1024 * 1024) {
        TARGET_PARTS = 300;
    } else {
        TARGET_PARTS = 500;
    }

    // 按目标分片数计算初步 chunkSize
    let chunkSize = Math.ceil(fileSize / TARGET_PARTS);
    if (chunkSize < MIN_CHUNK) {
        chunkSize = MIN_CHUNK;
    }

    // 确保不超过最大分片数
    let numParts = Math.ceil(fileSize / chunkSize);
    if (numParts > MAX_PARTS) {
        chunkSize = Math.ceil(fileSize / MAX_PARTS);
        numParts = Math.ceil(fileSize / chunkSize);
    }

    return { chunkSize, numParts };
}

module.exports = {
    calculateChunkSize
};